import React from 'react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';
import ChatRoundedIcon from '@mui/icons-material/ChatRounded';
import { Link as RouterLink } from 'react-router-dom';

const DetailPage = ({ page }) => {
  if (!page) {
    return (
      <Paper sx={{ p: 3, borderRadius: 3 }}>
        <Typography variant="h5" fontWeight={700}>页面不存在</Typography>
      </Paper>
    );
  }

  return (
    <Stack spacing={2.2}>
      <Paper
        sx={{
          p: { xs: 3, md: 4 },
          borderRadius: 4,
          color: 'white',
          background: 'linear-gradient(145deg, #0f172a 0%, #1e3a8a 58%, #3b82f6 100%)'
        }}
      >
        <Typography variant="h3" sx={{ fontWeight: 800, mb: 1 }}>{page.title}</Typography>
        <Typography sx={{ fontSize: 17, maxWidth: 860, opacity: 0.95 }}>{page.intro}</Typography>
      </Paper>

      {page.blocks.map((block) => (
        <Paper key={block.title} sx={{ p: 3, borderRadius: 3, border: '1px solid #dbe7ff' }}>
          <Typography variant="h5" sx={{ fontWeight: 800 }}>{block.title}</Typography>
          <Box sx={{ mt: 1.2 }}>
            <Typography color="text.secondary" sx={{ lineHeight: 1.8 }}>{block.content}</Typography>
          </Box>
        </Paper>
      ))}

      <Paper sx={{ p: 3, borderRadius: 3, border: '1px solid #dbe7ff', background: '#f8fbff' }}>
        <Typography variant="h5" sx={{ fontWeight: 800 }}>
          {page.ctaTitle || '准备进入下一步？'}
        </Typography>
        <Typography color="text.secondary" sx={{ mt: 1, lineHeight: 1.8 }}>
          {page.ctaDescription || '如果你已经有明确目标，可以直接进入咨询入口生成项目摘要。'}
        </Typography>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.2} sx={{ mt: 2 }}>
          <Button component={RouterLink} to="/consultation" variant="contained" startIcon={<ChatRoundedIcon />}>
            进入咨询入口
          </Button>
          <Button component={RouterLink} to="/cases" variant="outlined" startIcon={<LaunchRoundedIcon />}>
            查看案例参考
          </Button>
        </Stack>
      </Paper>
    </Stack>
  );
};

export default DetailPage;
